import React, { FC } from 'react';
import type { StepPageProps } from '../../../assessment-portal';
import WelcomePage from '../welcome-page';

const WelcomeStep: FC<StepPageProps> = ({ onNext }) => (
  <WelcomePage onNext={() => onNext({})} />
);

export default WelcomeStep;
